import { colors } from '@factorialco/deprecated-design-system'

const FULL_WIDTH = 1
const NO_WIDTH = 0
export const MIN_THRESHOLD = 0.05 // Minimum threshold for visibility

type KeyType = 'scheduled' | 'extra' | 'paidBreaks' | 'blankSlate'
const KeyType = {
  Scheduled: 'scheduled',
  Extra: 'extra',
  PaidBreaks: 'paidBreaks',
  BlankSlate: 'blankSlate',
}

const keyColorMap = {
  [KeyType.Scheduled]: colors.viridian1000,
  [KeyType.Extra]: colors.malibu1000,
  [KeyType.PaidBreaks]: colors.tangerine1000,
  [KeyType.BlankSlate]: colors.grey300,
}

export const keys = Object.keys(keyColorMap)
export const barColors = Object.values(keyColorMap)

type Data = {
  [key in KeyType]: number
}

export const generateData = (
  scheduled = NO_WIDTH,
  extra = NO_WIDTH,
  paidBreaks = NO_WIDTH
): Data[] => {
  const total = scheduled + extra + paidBreaks

  const normalize = (value: number) => {
    if (total === 0) return 0

    if (value > 0) {
      return Math.max(value / total, MIN_THRESHOLD)
    }
    return 0
  }

  const normalizedScheduled = normalize(scheduled)
  const normalizedExtra = normalize(extra)
  const normalizedPaidBreaks = normalize(paidBreaks)

  const blankSlate =
    normalizedScheduled === 0 && normalizedExtra === 0 && normalizedPaidBreaks === 0
      ? FULL_WIDTH
      : NO_WIDTH

  return [
    {
      scheduled: normalizedScheduled,
      extra: normalizedExtra,
      paidBreaks: normalizedPaidBreaks,
      blankSlate,
    },
  ]
}
